<template>
  <BaseReferenceTable
    title="Типы СМИ"
    entity-name="Тип СМИ"
    :headers="headers"
    :api="api"
    no-data-icon="mdi-newspaper"
    no-data-text="Типы СМИ не найдены"
    @load-data="loadData"
    @create-item="createItem"
    @update-item="updateItem"
    @delete-item="deleteItem"
  >
    <!-- Form fields for create/edit dialog -->
    <template #form-fields="{ item }">
      <v-text-field
        v-model="item.name"
        label="Название типа СМИ"
        placeholder="Информационное агентство, Новостной портал..."
        :rules="nameRules"
        required
        density="compact"
      ></v-text-field>
    </template>

    <!-- Custom table columns -->
    <template v-slot:[`item.name`]="{ item }">
      <span class="font-weight-medium">{{ item.name }}</span>
    </template>
  </BaseReferenceTable>
</template>

<script>
// import { ref } from 'vue' // убрано - не используется
import BaseReferenceTable from './BaseReferenceTable.vue'
import { referenceApi } from '@/services/api/referenceApi'

export default {
  name: 'MediaKindsTable',
  components: {
    BaseReferenceTable
  },
  setup() {
    const api = referenceApi

    const headers = [
      { 
        title: 'Название', 
        key: 'name', 
        sortable: true 
      }
    ]

    // Validation rules
    const nameRules = [
      v => !!v || 'Название типа СМИ обязательно',
      v => (v && v.length >= 1 && v.length <= 100) || 'Название должно содержать от 1 до 100 символов'
    ]

    // Methods
    const loadData = async ({ page, limit, callback }) => {
      try {
        const skip = (page - 1) * limit
        const response = await api.getMediaKinds({ skip, limit })
        callback(response.data)
      } catch (error) {
        console.error('Error loading media kinds:', error)
        callback(null, 'Ошибка загрузки типов СМИ. Проверьте подключение к серверу.')
      }
    }

    const createItem = async ({ item, callback }) => {
      try {
        await api.createMediaKind(item)
        callback(true)
      } catch (error) {
        console.error('Error creating media kind:', error)
        const message = error.response?.data?.detail || error.response?.data?.message || 'Не удалось создать тип СМИ'
        callback(false, message)
      }
    }

    const updateItem = async ({ item, callback }) => {
      try {
        await api.updateMediaKind(item.id, item)
        callback(true)
      } catch (error) {
        console.error('Error updating media kind:', error)
        const message = error.response?.data?.detail || error.response?.data?.message || 'Не удалось обновить тип СМИ'
        callback(false, message)
      }
    }

    const deleteItem = async ({ ids, callback }) => {
      try {
        await Promise.all(ids.map(id => api.deleteMediaKind(id)))
        callback(true)
      } catch (error) {
        console.error('Error deleting media kinds:', error)
        const message = error.response?.data?.detail || error.response?.data?.message || 'Не удалось удалить типы СМИ'
        callback(false, message)
      }
    }


    return {
      api,
      headers,
      nameRules,
      loadData,
      createItem,
      updateItem,
      deleteItem
    }
  }
}
</script>